import SoftwarePage from './SoftwarePage';
export default SoftwarePage;
